/* Used global Wordpress php variables to the ajax requests */

/* eslint-disable */
const {ajax_url, security, lang} = phpvars;
/* eslint-enable */

/**
 * GeoSwitcher Class
 */
export class GeoSwitcher {

	/**
	 * Constructs a new instance of the class.
	 *
	 * @class
	 * @memberof className
	 *
	 * @return {void}
	 */
	constructor() {

		/* eslint-disable */
		this.ajaxUrl = ajax_url;
		this.lang = lang;
		this.security = security;
		this.close = this.getCookie( 'geoswitcherClose=' );
        /* eslint-enable */

		this.setLang();

	}

	/**
	 * Initializes the event listeners for the geobar functionality.
	 * This function handles switching between different geographic options on a webpage.
	 */
	eventGeobar = () => {

		const selectedItem = document.querySelector( '.geoswitcher ul li.selected' );
		if ( selectedItem ) {

			const val = selectedItem.getAttribute( 'data-value' );
			const select = document.querySelector( '.geoswitcher select[name="lang"]' );
			if ( select ) {

				select.value = val;

			}

		}

		const geoswitcherItems = document.querySelectorAll( '.geoswitcher ul li' );

		geoswitcherItems.forEach( function eachItem( item ) {

			item.addEventListener( 'click', function clickItem( ) {

				const val = this.getAttribute( 'data-value' );

				geoswitcherItems.forEach( function eachItem2( otherItem ) {

					otherItem.classList.remove( 'selected' );

				} );

				this.classList.add( 'selected' );

				document.querySelector( '.geoswitcher select[name="lang"]' ).value = val;

			} );

		} );

		const redirect = document.querySelector( '.geoswitcher__redirect' );
		if ( redirect ) {

			redirect.addEventListener( 'click', () => {

				this.setCookie( 'geoswitcherClose', 'true' )

				const url = document.querySelector( 'select[name="lang"]' ).value;
				window.location = url;

			} );

		}

		const close = document.querySelector( '.geoswitcher__close' );
		if ( close ) {

			close.addEventListener( 'click', () => {

				this.setCookie( 'geoswitcherClose', 'true' );

				const geoswitcher = document.querySelector( '.geoswitcher' );
				geoswitcher.parentNode.removeChild( geoswitcher );

			} );

		}

	}

	/**
	 * Asynchronous function to set the language on the page by making a fetch request to the server.
	 *
	 * If the 'close' property is not set or if it is set to a non-true value, the function will fetch data
	 * based on the 'data-id' attribute of the document body and send a POST request to the specified 'ajaxUrl'.
	 *
	 * The response is expected to contain JSON data with a 'client' object that includes a 'language_code' property.
	 * If the retrieved language code is different from the one stored in 'phpvars.lang', the function will
	 * insert the specified view at the beginning of the document body and trigger the 'eventGeobar' function.
	 */
	setLang = () => {

		// Fetch

		if ( ! this.close || ( this.close && this.close !== 'true' ) ) {

			const dataId = document.body.getAttribute( 'data-id' );

			const data = new FormData();
			data.append( 'action', 'geoswitcher' );
			data.append( 'security', this.security );
			data.append( 'page_id', dataId );

			fetch( `${ this.ajaxUrl }`, {
				method: 'POST',
				credentials: 'same-origin',
				body: data,
			} )
				.then( ( res ) => res.text() )
				.then( ( response ) => {

					if ( response ) {

						const responseJson = JSON.parse( response ).data;

						if ( responseJson && responseJson.client && responseJson.languages && responseJson.client.language_code ) {

							if (
								responseJson &&
                                responseJson.client &&
                                responseJson.client.language_code &&
                                responseJson.languages.hasOwnProperty( responseJson.client.language_code ) &&
                                responseJson.client.language_code !== lang
							) {

								const header = document.querySelector( 'header' );
								if ( header ) {

									header.insertAdjacentHTML( 'afterbegin', responseJson.view );

								}

								this.eventGeobar();

							}

						}

					}

				} );

		}

	}

	/**
	 * Sets a cookie with the given name and value.
	 *
	 * @param {string} name - The name of the cookie.
	 * @param {string} value - The value of the cookie.
	 * @return {undefined} - This function does not return anything.
	 */
	setCookie = ( name, value ) => {

		const exdays = 1;
		const d = new Date();
		d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
		const expires = `expires=${ d.toUTCString() }`;

		document.cookie = `${ name }=${ value };${ expires };path=/`;

	}

	/**
	 * Retrieves the value of a cookie by name.
	 *
	 * @param {string} name - The name of the cookie to retrieve.
	 * @return {string} - The value of the cookie, or an empty string if the cookie does not exist.
	 */
	getCookie = ( name ) => {

		let cookieValue = '';
		const cookies = document.cookie.split( ';' );

		for ( let i = 0; i < cookies.length; i++ ) {

			let cookie = cookies[ i ];
			while ( cookie.charAt( 0 ) === ' ' ) {

				cookie = cookie.substring( 1 );

			}
			if ( cookie.indexOf( name ) === 0 ) {

				cookieValue = cookie.substring( name.length );

			}

		}

		return cookieValue;

	}

}

/* eslint-enable */
